let initialised = false;

export default function () {
    const $config = useRuntimeConfig();
    const nuxtApp = useNuxtApp();

    const init = async function () {
        if (initialised) return true;
        if (!import.meta.client) return false;
        const recaptcha = await import('vue3-recaptcha-v2');
        nuxtApp.vueApp.use(recaptcha.install, {
            sitekey: $config.public.reCaptchaSiteKey,
            cnDomains: false,
        });
        initialised = true;
        return true;
    };

    return {init};
}
